require('./brokerInvestBehaviorGraphics.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { ComparativeBarComposed } = require('commonsComponents/comparativeBarComposed');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { Link } = require('react-router-dom');

class BrokerInvestBehaviorGraphics extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const BAR_HEIGHT = 4;
        const FIRST_COLOR = '#002b45';
        const SECOND_COLOR = '#E3E9E9';

        const valueHeaderLabel = formatText('broker-investGraphicsValueHeaderLabel');
        const buyHeaderLabel = formatText('broker-investGraphicsBuyHeaderLabel');
        const sellHeaderLabel = formatText('broker-investGraphicsSellHeaderLabel');
        const operateHeaderLabel = formatText('broker-investGraphicsOperateHeaderLabel');
        const buyButtonLabel = formatText('broker-investGraphicsBuyButtonLabel');

        const { invests } = this.props;

        const graphicRows = invests.map((invest, index) => {
            const instrumentId = invest.get('instrumentId') ? invest.get('instrumentId').trim() : '';
            const miccode = invest.get('miccode') ? invest.get('miccode').trim() : '';
            const buyUrl = `/myprofile/broker/stocksBuy/${instrumentId}/${miccode}`;
            const stockUrl = `/myprofile/broker/productFile/${instrumentId}/${miccode}`;
            return (
                <OKTableRow key={index} className="broker-invest-behavior-graphics__table-row">
                    <OKTableCell
                        alignment="center"
                        className="broker-invest-behavior-graphics__table-cell broker-invest-behavior-graphics__table-cell--value"
                    >
                        <div className="broker-invest-behavior-graphics__bar-group">
                            <Link className="ok-link ok-link--on-table broker-invest-behavior-graphics__stock" to={stockUrl}>
                                {invest.get('stock')}
                            </Link>
                            <div className="broker-invest-behavior-graphics__bar-container">
                                <ComparativeBarComposed
                                    firstValue={invest.get('buyValue')}
                                    secondValue={invest.get('sellValue')}
                                    totalValue={invest.get('buyValue') + invest.get('sellValue')}
                                    firstColor={FIRST_COLOR}
                                    secondColor={SECOND_COLOR}
                                    height={BAR_HEIGHT}
                                />
                            </div>
                        </div>
                    </OKTableCell>
                    <OKTableCell 
                        alignment="right"
                        className="broker-invest-behavior-graphics__table-cell broker-invest-behavior-graphics__table-cell--buy"
                    >
                        {invest.get('buyValue')}%
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-invest-behavior-graphics__table-cell broker-invest-behavior-graphics__table-cell--sell"
                    >
                        {invest.get('sellValue')}%
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        className="broker-invest-behavior-graphics__table-cell broker-invest-behavior-graphics__table-cell--operate"
                    >
                        <OKButton modifier="secondary" size="compact" onClick={() => this.props.onHandleBuyClick(buyUrl, invest.get('stock'))}>
                            {buyButtonLabel}
                        </OKButton>
                    </OKTableCell>
                </OKTableRow>
            )
        });

        return (
            <div className="broker-invest-behavior-graphics">
                <OKTable className="broker-invest-behavior-graphics__table">
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                width="44%"
                            >
                                {valueHeaderLabel}
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="19%"
                            >
                                {buyHeaderLabel}
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="17%"
                            >
                                {sellHeaderLabel}
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="20%"
                            >
                                {operateHeaderLabel}
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {graphicRows}
                    </tbody>
                </OKTable>
            </div>
        );
    }
}

BrokerInvestBehaviorGraphics.propTypes = {
    invests: PropTypes.object,
    onHandleBuyClick: PropTypes.func
}

BrokerInvestBehaviorGraphics.contextTypes =  {
    router: PropTypes.object.isRequired
};

module.exports = BrokerInvestBehaviorGraphics;
